import { useLanguage } from '@/i18n/LanguageContext';

export const BehaviorCard = ({ label, pct, count, total, accent }) => {
  const { t } = useLanguage();
  const pctSafe = typeof pct === 'number' ? pct : 0;
  const width = Math.min(100, Math.max(0, pctSafe));
  return (
    <div className="bg-card border border-border rounded-sm p-4">
      <p className="text-xs text-muted-foreground mb-1">{label}</p>
      <p className="text-2xl font-bold font-mono">{pctSafe.toFixed(1)}%</p>
      <p className="text-xs text-muted-foreground mt-1">
        {count} / {total} {t('analytics.paidOrders').toLowerCase()}
      </p>
      <div className="mt-3 h-1.5 w-full rounded-full bg-muted overflow-hidden">
        <div className={`h-full ${accent} rounded-full transition-all`} style={{ width: `${width}%` }} />
      </div>
    </div>
  );
};
